module.exports = __webpack_public_path__ + "components/icon/static/moonrise-4e7fa9aadae3f6b914970d28dc7926e1.svg";